module.exports = __webpack_public_path__ + "img/case11.fdc6155d.png";